<template>
  <div class="sea-plus-icon" :style="{ 'background-image': 'url(\'/ic-sea-plus-small.png\')' }"></div>
</template>

<style scoped>
.sea-plus-icon {
  margin-left: 10px;
  width: 100px;
  height: 70%;
  background-size: contain;
  background-position: 0 50%;
}
</style>

<script>
export default {}
</script>
